import { connect } from "react-redux";
import colores from "../../shared/constants/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

interface AlertaImpuestosProps {
  open: boolean;
  handleClose: () => void;
}

const AlertaImpuestos = (props: AlertaImpuestosProps) => {
  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"ATENCIÓN"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Si la entrega es realizada por Barbieri, el pedido estará sujeto al
          cargo correspondiente por embalaje y seguro.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button
          className="btn btn-danger"
          type="button"
          onClick={props.handleClose}
          style={{
            backgroundColor: colores.rojo,
            padding: "0.625rem",
            marginTop: "1.25rem",
            inlineSize: "10rem",
            marginLeft: "1rem",
          }}
        >
          Siguiente
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default connect()(AlertaImpuestos);
